import { render, staticRenderFns } from "./ClientAndContactPersonDetails.vue?vue&type=template&id=03d292de&scoped=true"
import script from "./ClientAndContactPersonDetails.vue?vue&type=script&lang=ts"
export * from "./ClientAndContactPersonDetails.vue?vue&type=script&lang=ts"
import style0 from "./ClientAndContactPersonDetails.vue?vue&type=style&index=0&id=03d292de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d292de",
  null
  
)

export default component.exports